import React from "react"
import { AdFormEmailPassword } from "../StepContent/AdFormEmailPassword"
import { ExperienceYears } from "../StepContent/ExperienceYears"
import { AdFormBasicInfo } from "../StepContent/AdFormBasicInfo"
import { Prefecture } from "../StepContent/Prefecture"
import { Tel } from "../StepContent/Tel"
import { CompanyName } from "../StepContent/CompanyName"
import { EmploymentStatus } from "../StepContent/EmploymentStatus"
import { EnrollmentPeriod } from "../StepContent/EnrollmentPeriod"
import { CuisineGenre } from "../StepContent/CuisineGenre/CuisineGenre"
import { JobContent } from "../StepContent/JobContent/JobContent"
import { DetailedWorkDetails } from "../StepContent/DetailedWorkDetails"
import { ContentConfirmation } from "../StepContent/ContentConfirmation"
import { AdFormFirstStep } from "../StepContent/AdFormFirstStep"

// ad_form 専用ステップ定義（13ステップ）
//
// index | コンポーネント
//   0   | AdFormFirstStep      - 1stステップ（在職/離職、注釈モーダル）
//   1   | ExperienceYears
//   2   | AdFormBasicInfo      - FullName + Birthday + Sex
//   3   | Prefecture
//   4   | Tel
//   5   | CompanyName
//   6   | EmploymentStatus
//   7   | EnrollmentPeriod
//   8   | CuisineGenre
//   9   | JobContent
//  10   | DetailedWorkDetails
//  11   | AdFormEmailPassword  - ログイン用のemail/password設定
//  12   | ContentConfirmation

export type AdFormStep = {
    Component: React.ComponentType
    // 3ドットのプログレスバー中の位置（0〜2。確認画面のみ全ドット完了を表す3）
    sectionDot: number
}

const AD_FORM_STEPS: AdFormStep[] = [
    { Component: AdFormFirstStep, sectionDot: 0 },
    { Component: ExperienceYears, sectionDot: 0 },
    { Component: AdFormBasicInfo, sectionDot: 0 },
    { Component: Prefecture, sectionDot: 0 },
    { Component: Tel, sectionDot: 0 },
    { Component: CompanyName, sectionDot: 1 },
    { Component: EmploymentStatus, sectionDot: 1 },
    { Component: EnrollmentPeriod, sectionDot: 1 },
    { Component: CuisineGenre, sectionDot: 1 },
    { Component: JobContent, sectionDot: 1 },
    { Component: DetailedWorkDetails, sectionDot: 1 },
    { Component: AdFormEmailPassword, sectionDot: 2 },
    // sectionDotを3（全ドット数）にすることで、AdFormProgressBannerのgetDotStatusが
    // 追加の特殊分岐なしに全ドット完了扱いで描画する（確認画面＝全セクション完了の表現）
    { Component: ContentConfirmation, sectionDot: 3 },
]

/**
 * ad_form のステップ定義を返す
 *
 * @returns 13ステップ分の定義（index順に表示される）
 */
export const getAdFormSteps = (): AdFormStep[] => AD_FORM_STEPS
